/* globals performance: false */
mtl.alloy.factory.origami = (function($, mtl) {
	'use strict';

	// Offset tweener.
	// ---------------------------------------------------------

	/**
	 * Get a helper that provides tweening between two offet arrays.
	 */
	function createOffsetTweener(initialOffsets, _duration, _easing) {

		var easing = _easing || 'swing';
		var duration = _duration ? (_duration | 0) : 400;

		var finalOffsets = initialOffsets;
		var tweenedOffsets = initialOffsets;

		var isAnimating = false;
		var tweenAmount = 1;
		var lastTickTime = 0;


		/**
		 * Get tweened offsets for the current time.
		 */
		function getTweenedOffsets() {

			if (tweenedOffsets) {
				return tweenedOffsets;
			}

			var blend = $.easing[easing](tweenAmount);

			var offsets = [];
			for (var i = 0, ix = finalOffsets.length; i < ix; i++) {
				offsets.push(
					finalOffsets[i] * blend +
					initialOffsets[i] * (1.0 - blend)
				);
			}

			return (tweenedOffsets = offsets);

		}


		/**
		 * Start tweening to the given offsets.
		 */
		function tweenTo(offsets) {

			tweenedOffsets = initialOffsets = getTweenedOffsets();
			finalOffsets = offsets;

			isAnimating = true;

			tweenAmount = 0.0;
			lastTickTime = +performance.now();

		}


		/**
		 * Execute a tick.
		 */
		function tick() {

			var tickTime = +performance.now();

			var period = Math.max(0.0, (tickTime - lastTickTime) / duration);

			lastTickTime = tickTime;

			tweenAmount += period;
			if (tweenAmount >= 1.0) {
				isAnimating = false;
				tweenAmount = 1.0;
			}

			tweenedOffsets = null;

		}


		// Return public API
		return {
			isAnimating: function() { return isAnimating; },
			getTweenAmount: function() { return tweenAmount; },
			getTweenedOffsets: getTweenedOffsets,
			tweenTo: tweenTo,
			tick: tick,
		};

	}


	// HTML Origami controller.
	// ---------------------------------------------------------

	/**
	 * Create a HTML controller instance.
	 */
	function createHTMLController($element, $items) {

		var $dividers = null;


		/**
		 * Create vertical dividers.
		 */
		function createDividers(_width, _color) {

			var width  = +_width;
			var color  = _color ? (_color + '') : 'currentColor';
			var margin = width * -0.5;

			var html = '<div style="' +
				'pointer-events: none;' +
				'position: absolute;' +
				'top: 0;' +
				'bottom: 0;' +
				'width: ' + width + 'px;' +
				'margin-left: ' + margin + 'px;' +
				'background: ' + color + ';' +
			'"></div>';

			if ($dividers) {
				$dividers.remove();
			}

			$dividers = $($.parseHTML(
				(new Array($items.length)).join(html)
			)).appendTo($element);

		}


		/**
		 * Set the active (hovered) index.
		 */
		function activateIndex(_index) {

			var index = _index | 0;

			$items.each(function(i) {
				$(this)
					.toggleClass('is-active', i === index)
					.toggleClass('is-disabled', index > -1 && i !== index)
				;
			});

		}


		/**
		 * Set offsets.
		 */
		function setOffsets(offsets) {

			// Update items with new offsets
			$items.each(function(i) {
				$(this).css({
					left:  (offsets[i] * 100) + '%',
					right: (100 - offsets[i + 1] * 100) + '%',
				});
			});

			// Update dividers with new offsets
			if ($dividers) {
				$dividers.each(function(i) {
					$(this).css({
						left:  (offsets[i + 1] * 100) + '%',
					});
				});
			}

		}


		/**
		 * Remove background elements.
		 */
		function removeBackground() {

			$element.find('.id-origami-bg').remove();

		}


		/**
		 * Attach a WebGL canvas to the HTML.
		 */
		function attachCanvas(canvas) {

			$element.append(canvas);

		}


		// Return public API
		return {
			setOffsets: setOffsets,
			activateIndex: activateIndex,
			createDividers: createDividers,
			removeBackground: removeBackground,
			attachCanvas: attachCanvas,
		};

	}


	// WebGL Origami controller.
	// ---------------------------------------------------------

	/**
	 * Create a canvas element.
	 */
	function createCanvas(width, height) {

		try {

			var canvas = document.createElement('canvas');
			if (!canvas) {
				return null;
			}

			canvas.width  = width  | 0;
			canvas.height = height | 0;

			return canvas;

		}

		catch (error) {
			console.error(error);
		}

		return null;

	}


	/**
	 * Convert a hexadecimal colour reference into a WebGL-friendly 4-component array.
	 */
	function hexToColorArray(_hex) {

		var hex = (_hex.substr(0, 1) === '#') ? _hex.substr(1) : _hex;

		var dec = parseInt(hex, 16);

		return [
			((dec & 0xff0000) >> 16) / 255,
			((dec & 0x00ff00) >> 8) / 255,
			(dec & 0x0000ff) / 255,
			1
		];

	}


	/**
	 * Create a WebGL controller instance.
	 */
	function createGLController($element, images, offsets, options) {

		// Early-exit if WebGL is not supported
		if (!window.WebGLRenderingContext) {
			return null;
		}

		// Get the width and height of the canvas
		var width  = $element.width()  | 0;
		var height = $element.height() | 0;

		// Try to create a <canvas> element
		var canvas = createCanvas(width, height);
		if (!canvas) {
			return null;
		}

		// Try to get a WebGL context
		var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
		if (!gl) {
			return null;
		}

		var isDirty = false;

		var program;

		var vshPositionLocation;
		var vshPositionBuffer;

		var vshTexCoordLocation;
		var vshTexCoordBuffer;

		var dividerWidth = 0;

		var quads = [];

		var imageAlignWeight = (options.imageAlign != null) ? +options.imageAlign : 0.5;


		/**
		 * @fixme This is crappy plz make it better
		 */
		function updateDimensions() { 

			var _width  = $element.width()  | 0;
			var _height = $element.height() | 0;

			if (_width !== width || _height !== height) {
				canvas.width  = width  = _width;
				canvas.height = height = _height;
				gl.viewport(0, 0, width, height);
				gl.uniform2f(gl.getUniformLocation(program, 'u_resolution'), width, height);
				return true;
			}

			return false;

		}


		/**
		 * Create a quad instance.
		 */
		function createQuad(color) {

			var a_position = new Float32Array(8);
			var a_texCoord = new Float32Array(8);

			var texture = gl.createTexture();
			var image = null;

			var blendTween = createOffsetTweener([0]);

			gl.bindTexture(gl.TEXTURE_2D, texture);
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
			gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array(hexToColorArray(color || 'ffffff')));


			/**
			 * Load an image.
			 */
			function loadImage(src) {

				var loader = new Image();

				loader.onload = function() {

					gl.bindTexture(gl.TEXTURE_2D, texture);
					gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, loader);

					blendTween.tweenTo([1]);

					image = loader;
					loader = loader.onload = null;

					isDirty = true;

				};

				loader.src = src;

			}


			/**
			 * Set the screen-space coordinates of each corner.
			 */
			function setCoordinates(x1, y1, x2, y2, x3, y3, x4, y4) {

				isDirty = true;

				a_position[0] = x3;
				a_position[1] = y3;

				a_position[2] = x1;
				a_position[3] = y1;

				a_position[4] = x2;
				a_position[5] = y2;

				a_position[6] = x4;
				a_position[7] = y4;

				if (image) {

					var imageWidth = image.naturalWidth;
					var imageHeight = image.naturalHeight;

					var xL = (x1 + x3) * 0.5;
					var xR = (x2 + x4) * 0.5;
					var xC = (xL + xR) * 0.5;
					var yC = (y1 + y2 + y3 + y4) * 0.25;

					var quadWidth = (xR - xL);
					var diffWidth = Math.max(0, quadWidth - imageWidth);

					xC += diffWidth * (imageAlignWeight - 0.5);

					a_texCoord[0] = 0.5 - (xC - x3) / imageWidth;
					a_texCoord[1] = 0.5 - (yC - y3) / imageHeight;

					a_texCoord[2] = 0.5 - (xC - x1) / imageWidth;
					a_texCoord[3] = 0.5 - (yC - y1) / imageHeight;

					a_texCoord[4] = 0.5 - (xC - x2) / imageWidth;
					a_texCoord[5] = 0.5 - (yC - y2) / imageHeight;

					a_texCoord[6] = 0.5 - (xC - x4) / imageWidth;
					a_texCoord[7] = 0.5 - (yC - y4) / imageHeight;

				}

			}


			/**
			 * Draw the quad.
			 */
			function draw() {

				gl.bindBuffer(gl.ARRAY_BUFFER, vshPositionBuffer);
				gl.bufferSubData(gl.ARRAY_BUFFER, 0, a_position);

				gl.bindBuffer(gl.ARRAY_BUFFER, vshTexCoordBuffer);
				gl.bufferSubData(gl.ARRAY_BUFFER, 0, a_texCoord);

				gl.bindTexture(gl.TEXTURE_2D, texture);

				blendTween.tick();
				gl.uniform1f(gl.getUniformLocation(program, 'u_blend'), blendTween.getTweenedOffsets()[0]);

				gl.drawArrays(gl.TRIANGLE_FAN, 0, 4);

			}


			// Return public API
			return {
				setCoordinates: setCoordinates,
				isAnimating: function() { return blendTween.isAnimating(); },
				loadImage: loadImage,
				draw: draw,
			};

		}


		/**
		 * Create coloured divider lines between each image.
		 */
		function createDividers(_width, _color) {

			dividerWidth = _width | 0;

			gl.clearColor.apply(gl, hexToColorArray(_color));

		}


		/**
		 * Set new offsets.
		 */
		function setOffsets(_offsets) {

			isDirty = true;

			offsets = _offsets;

		}


		/**
		 * Get the vertex shader code.
		 */
		function getVertexShader() {

			var code = [
				'uniform    vec2   u_resolution;',

				'attribute  vec2   a_position;',
				'attribute  vec2   a_texCoord;',
				'// attribute  float  a_blend;',

				'varying    vec2   v_texCoord;',

				'void main() {',
					'vec2 clipSpace = ((a_position / u_resolution) * 2.0) - 1.0;',
					'gl_Position = vec4(clipSpace * vec2(1.0, -1.0), 0.0, 1.0);',
					'v_texCoord = a_texCoord;',
				'}',
			];

			return code.join('\n');

		}


		/**
		 * Get the fragment shader code.
		 */
		function getFragmentShader() {

			var code = [
				'precision mediump float;',

				'uniform    sampler2D  u_image;',
				'uniform    float      u_blend;',

				'varying    vec2   v_texCoord;',

				'void main() {',
					'gl_FragColor = texture2D(u_image, v_texCoord) * u_blend;',
				'}',
			];

			return code.join('\n');

		}


		/**
		 * Compile a shader.
		 */
		function compileShader(gl, shaderSource, shaderType) {

			var shader = gl.createShader(shaderType);
			gl.shaderSource(shader, shaderSource);
			gl.compileShader(shader);

			// Check the compile status
			var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
			if (!compiled) {

				console.error('Error compiling shader: ' + gl.getShaderInfoLog(shader));
				gl.deleteShader(shader);
				return null;

			}

			return shader;

		}


		/**
		 * Initialise the context and scene.
		 */
		function init() {

			try {

				// Create and link a shader program
				program = gl.createProgram();

				gl.attachShader(program, compileShader(gl, getVertexShader(), gl.VERTEX_SHADER));
				gl.attachShader(program, compileShader(gl, getFragmentShader(), gl.FRAGMENT_SHADER));

				gl.linkProgram(program);
				if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
					gl.deleteProgram(program);
					throw new Error('Program not linked');
				}

				gl.useProgram(program);

				// Create the `a_position` buffer
				vshPositionLocation = gl.getAttribLocation(program, 'a_position');
				vshPositionBuffer = gl.createBuffer();

				// Create the `a_texCoord` buffer
				vshTexCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
				vshTexCoordBuffer = gl.createBuffer();

				// Configure and pre-fill the `a_position` buffer
				gl.bindBuffer(gl.ARRAY_BUFFER, vshPositionBuffer);
				gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(8), gl.DYNAMIC_DRAW);
				gl.enableVertexAttribArray(vshPositionLocation);
				gl.vertexAttribPointer(vshPositionLocation, 2, gl.FLOAT, false, 0, 0);

				// Configure and pre-fill the `a_texCoord` buffer
				gl.bindBuffer(gl.ARRAY_BUFFER, vshTexCoordBuffer);
				gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(8), gl.DYNAMIC_DRAW);
				gl.enableVertexAttribArray(vshTexCoordLocation);
				gl.vertexAttribPointer(vshTexCoordLocation, 2, gl.FLOAT, false, 0, 0);

				// Set the canvas size for screen space -> clip space transformation
				gl.uniform2f(gl.getUniformLocation(program, 'u_resolution'), width, height);

				// Create a quad for each image
				quads = images.map(function(src, i) {
					var quad = createQuad(i === 1 ? 'ff8888' : '8888ff');
					quad.loadImage(src);
					return quad;
				});

				// Flag
				isDirty = true;

			}

			catch (error) {
				console.error(error.stack);
				return false;
			}

			return true;

		}


		/**
		 * Is an animation is progress?
		 */
		function isAnimating() {

			for (var i = 0, ix = quads.length; i < ix; i++) {
				if (quads[i].isAnimating()) {
					return true;
				}
			}

			return false;

		}


		/**
		 * Draw the scene.
		 */
		function draw() {

			if (updateDimensions()) {
				isDirty = true;
			}

			if (!isDirty && !isAnimating()) {
				return;
			}

			var angleStrength = (options.angleStrength != null) ? +options.angleStrength : 1;

			gl.clear(gl.COLOR_BUFFER_BIT);

			var ix = quads.length;
			quads.forEach(function(quad, i) {

				var x1 = offsets[i];
				var x2 = offsets[i + 1];

				var x3 = x1;
				var x4 = x2;

				var d1 = 0;
				var d2 = 0;

				// Not first
				if (i > 0) {
					x1 = (x1 - 0.5) * (1 + 0.3 * angleStrength) + 0.5;
					x3 = (x3 - 0.5) * (1 - 0.1 * angleStrength) + 0.5;
					d1 = dividerWidth * 0.5;
				}

				// Not last
				if (i + 1 < ix) {
					x2 = (x2 - 0.5) * (1 + 0.3 * angleStrength) + 0.5;
					x4 = (x4 - 0.5) * (1 - 0.1 * angleStrength) + 0.5;
					d2 = dividerWidth * 0.5;
				}

				quad.setCoordinates(
					x1 * width + d1, 0,
					x2 * width - d2, 0,
					x3 * width + d1, height,
					x4 * width - d2, height
				);

				quad.draw();

			});

			isDirty = false;

		}


		// Return public API
		return {
			canvas: canvas,
			createDividers: createDividers,
			setOffsets: setOffsets,
			init: init,
			draw: draw,
		};

	}



	// Offset calculation.
	// ---------------------------------------------------------

	/**
	 * Get default offsets.
	 */
	function getDefaultOffsets(_length) {

		var length = _length | 0;

		var offsets = [];

		for (var i = 0; i <= length; i++) {
			offsets.push(i / length);
		}

		return offsets;

	}


	/**
	 * Get weighted offets.
	 */
	function getWeightedOffsets(weightedIndex, length, activeWeight) {

		weightedIndex = weightedIndex | 0;
		length = length | 0;
		activeWeight = (activeWeight != null) ? +activeWeight : 1;

		var i = 0;

		var itemWeight = 0;
		var totalWeight = 0;

		var weights = [];
		for (i = 0; i < length; i++) {
			totalWeight += (itemWeight = (i === weightedIndex ? length * activeWeight : 1));
			weights.push(itemWeight);
		}

		var offsets = [0.0];
		var lastOffset = 0.0;
		for (i = 0; i < length; i++) {
			lastOffset += weights[i] / totalWeight;
			offsets.push(lastOffset);
		}

		return offsets;

	}


	// Core functionality.
	// ---------------------------------------------------------

	/**
	 * Origami factory for desktop.
	 */
	function desktopOrigami(element, options) {

		var $container = $(element).parent();
		var $element = $(element).first();
		var $items = $element.children();

		var defaultOffsets = getDefaultOffsets($items.length);

		// Create a controller for the HTML widget
		var htmlController = createHTMLController($element, $items, options);

		var images = $element.find('.id-origami-img').toArray().map(function(img) {
			return img.src;
		});

		// Create a controller for the WebGL widget
		var glController = createGLController($element, images, defaultOffsets, options);
		if (!glController) {
			console.warning('WegGL not supported');
		}

		// Attach vertical dividers
		if (options.dividerWidth > 0) {
			(glController || htmlController).createDividers(options.dividerWidth, options.dividerColor);
		}

		// Initialise the WebGL scene
		if (glController) {

			// Success
			if (glController.init()) {
				htmlController.removeBackground();
				htmlController.attachCanvas(glController.canvas);
			}

			// Failed
			else {
				glController = null;
			}

		}


		// Get a tween helper
		var tweener = createOffsetTweener(defaultOffsets, options.duration, options.easing);
		var forceUpdate = true;


		// On mouseenter, activate a target slide
		$items.on('mouseenter', function(event) {

			var index = $items.index(event.currentTarget);

			$('.folding-wrapper', $container).addClass('is-active');

			tweener.tweenTo(getWeightedOffsets(index, $items.length, options.activeWeight));

			htmlController.activateIndex(index);

		});


		// On mouseleave, deactivate slides
		$element.on('mouseleave', function(event) {

			$('.folding-wrapper', $container).removeClass('is-active');

			tweener.tweenTo(defaultOffsets);

			htmlController.activateIndex(-1);

		});


		// Tick
		function tick() {

			// Keep ticking...
			requestAnimationFrame(tick);

			// Update the offsets
			if (forceUpdate || tweener.isAnimating()) {

				forceUpdate = false;

				tweener.tick();

				var offsets = tweener.getTweenedOffsets();

				htmlController.setOffsets(offsets);

				if (glController) {
					glController.setOffsets(offsets);
				}

			}

			// Draw the WebGL controller
			if (glController) {
				glController.draw();
			}

		}

		tick();

		$(window).on('resize orientationchange', function() {
			if(app.breakpoint.is('desktop'))
				$container.css('height','auto');
		});

	}


	/**
	 * Origami factory for mobile.
	 */
	function mobileOrigami(element, options) {

		var currentIndex = -1;
		var nextZ = 1;

		var $container = $(element).parent();

		var $element = $(element).first();
		var $items = $element.children()
			.addClass('is-active')
			.css({
				left: 0,
				right: 0,
			})
		;

		$items.each(function(){
			var href = $('.homepage-origami-item__body__buy-btn', $(this)).attr('href');
			$('.homepage-origami__bg img', $(this)).wrap('<a href="'+href+'"></a>');
		});

		/**
		 * Show the item at the given index.
		 */
		function showIndex(index, instant) {

			index = index | 0;
			if (index === currentIndex) {
				return;
			}

			$items.stop(true, false).each(function(i, item) {

				var isCurrent = (i === index);
				var wasCurrent = (i === currentIndex);

				if (instant) {
					$(item).css({
						opacity: (isCurrent) ? 1 : 0,
						zIndex:  (isCurrent) ? 1 : 0,
					});
					nextZ = 2;
				}

				else if (isCurrent) {
					$(item)
						.delay(200)
						.queueCSS({
							zIndex: nextZ++,
						})
						.animate({
							opacity: 1,
						}, 200)
					;
				}

				else if (wasCurrent) {
					$(item)
						.animate({
							opacity: 0,
						}, 200)
					;
				}

			});

			currentIndex = index;

		}


		/**
		 * Roll the index.
		 */
		function rollIndex(rollBy, instant) {

			rollBy = rollBy | 0;

			showIndex((currentIndex + rollBy) % $items.length, instant);

		}

		function setTallestItem($items, $container) {
			var tallestItemHeight = 0;
			$items.each(function(){
				var contentsHeight = 0;

				$(this).children().each(function(){
				    contentsHeight += $(this).outerHeight(true);
				});

				if(contentsHeight >= tallestItemHeight)
					tallestItemHeight = contentsHeight;
			});

			if(tallestItemHeight != 0)
				$container.height(tallestItemHeight);
		}


		// Start at index 0
		showIndex(0, true);

		setTallestItem($items, $container);

		$(window).on('resize orientationchange', function() {
			if(!app.breakpoint.is('desktop'))
				setTallestItem($items, $container);
		});

		// Automatically roll to the next index after ~3 seconds
		setInterval(rollIndex.bind(null, 1, false), 2500 + (Math.random() * 1000));

	}


	/**
	 * Origami factory.
	 */
	return function(element, options) {

		if($(element).parent().hasClass('homepage-origami'))
		{
			var mobileClone = $(element).clone().addClass('for-mobile');
			mobileClone.insertAfter($(element));
			mobileOrigami(mobileClone, options);
		}

		$(element).addClass('for-desktop');

		desktopOrigami(element, options);
		
	};


}($, mtl, app));
